<template>
  <section class="companies">
    <div class="float-left" v-if="simplify">
      <small
        v-if="sincronized == dataUsers.length"
        class="
          rounded-circle
          icon-checkmark
          bg-white
          border-secondary border
          text-white
        "
      ></small>
      <small
        v-else
        class="
          rounded-circle
          icon-checkmark
          bg-white
          border-secondary border
          text-white
        "
      ></small>
    </div>
    <div class="ml-4 mt-1" v-if="simplify">
      <h6>{{ $t("lang.preparingapp.defineyourteam") }}</h6>
      <small class="text-secondary">{{
        $t("lang.preparingapp.defineyourteam_desc")
      }}</small>
      <span class="my-4 border-top w-100"></span>
      <li v-for="(row, key) in dataUsers" :key="key">

        <small
          v-if="row.nylas_email_sync_status == 0"
          class="
            mr-1
            rounded-circle
            icon-checkmark
            bg-white
            border-secondary border
            text-white
          "
        ></small>
        <small v-if="row.nylas_email_sync_status == 1">
          <small
            class="p-1 rounded-circle icon-checkmark bg-primary text-white"
          ></small
        ></small>
        <small> {{ row.email }}</small>
        <button
          v-if="currentUser.email == row.email"
          @click="$router.push('/calendar_config')"
          class="btn btn-primary"
        >
          <small
            >{{ $t("lang.preparingapp.defineyourteam_btn") }}
            <i class="icon-calendar"></i
          ></small>
        </button>
      </li>
    </div>
    <div class="float-left" v-if="listProfileComplete">
      <small v-if="currentUser.avatar">
        <small
          class="p-1 rounded-circle icon-checkmark bg-primary text-white"
        ></small>
      </small>
      <small v-else>
        <small
          class="rounded-circle icon-checkmark bg-white border-secondary border text-white"
        ></small>
      </small>
    </div>
    <div class="ml-4 mt-1" v-if="listProfileComplete">
      <h6 class="mr-4">{{ $t("lang.preparingapp.complete_profile") }}</h6>
      <button
        v-if="isBilling || isSales"
        @click="gotProfile()"
        :class="
          proComplete
            ? 'float-right btn-primary btn btn-sm '
            : 'ml-1 float-right btn-outline-primary btn btn-sm '
        "
      >
        {{ $t("lang.preparingapp.complete_profile") }}
      </button>
      <small class="text-secondary">
        {{ $t("lang.preparingapp.define_complete_profile") }}
      </small>
    </div>
    <ol
      class="breadcrumb"
      v-if="currentUser.role_id != 1 && !simplify && !listProfileComplete"
    >
      <li class="breadcrumb-item active">{{ $t("lang.label.clientteam") }}</li>
    </ol>

    <main class="contenedor" v-if="!simplify && !listProfileComplete">
      <LoadingSpinner v-if="loading" />
      <div class="row" v-if="!loading">
        <div class="col-sm-12">
          <div class="card mt-3 p-4 client-team-card">
            <div class="client-team-header d-flex flex-wrap align-items-start justify-content-between mb-4">
              <div>
                <h4 class="client-team-title mb-1">
                  {{ $t('lang.label.client_team_users_title') }}
                  <span v-if="dataUsers && dataUsers.length" class="client-team-count">{{ dataUsers.length }}</span>
                </h4>
                <p class="client-team-subtitle text-secondary mb-0">
                  {{ $t('lang.label.client_team_users_subtitle') }}
                </p>
              </div>
              <section v-if="!hasDeclinedPayments" class="client-team-header-actions">
                <button
                  class="btn btn-primary"
                  @click="addSales"
                  type="submit"
                  v-if="currentUser.role_id == 4"
                >
                  <i class="icon-plus1"></i> {{ $t('lang.user.new') }}
                </button>
                <button
                  class="btn btn-primary"
                  @click="addUserTeam"
                  v-if="currentUser.role_id == 2 && currentUser.is_agency == 0"
                  type="submit"
                >
                  <i class="icon-plus1"></i> {{ $t("lang.user.new") }}
                </button>
              </section>
            </div>
            <div class="mt-1">
              <LoadingSpinner v-if="loadingteam" />
              <table class="table client-team-table mb-0" v-if="!loadingteam">
                <thead>
                  <tr>
                    <th scope="col">{{ $t('lang.label.client_team_col_user') }}</th>
                    <th scope="col">{{ $t('lang.label.client_team_col_role') }}</th>
                    <th scope="col" v-if="currentUser.is_agency == 1">{{ $t('lang.label.client_team_col_calendar_sync') }}</th>
                    <th scope="col" class="client-team-actions-col"></th>
                  </tr>
                </thead>
                <tbody v-if="dataUsers && dataUsers.length">
                  <tr v-for="(row, key) in dataUsers" :key="row.id || key">
                    <td>
                      <div class="d-flex align-items-center client-team-user-cell">
                        <div class="client-team-avatar"
                          :class="getAvatarColorClass(key)"
                        >
                          <img
                            v-if="row.avatar"
                            :src="row.avatar"
                            :alt="row.username"
                            class="client-team-avatar-img"
                          />
                          <img
                            v-else
                            :src="avatarPlaceholder"
                            :alt="row.username"
                            class="client-team-avatar-img"
                          />
                        </div>
                        <div class="ml-3">
                          <div class="client-team-user-name">
                            {{ row.username }}
                            <span v-if="isCurrentUser(row)" class="client-team-you-badge">{{ $t('lang.label.client_team_you_badge') }}</span>
                          </div>
                          <div class="client-team-user-email text-secondary">{{ row.email }}</div>
                        </div>
                      </div>
                    </td>
                    <td>
                      <span
                        class="client-team-role-badge"
                        :class="String(row.role_id) === '4' ? 'client-team-role-billing' : 'client-team-role-sales'"
                      >
                        <i :class="String(row.role_id) === '4' ? 'icon-file-text' : 'icon-at'"></i>
                        {{ getRoleLabel(row.role_id) }}
                      </span>
                    </td>
                    <td v-if="currentUser.is_agency == 1">
                      <div class="d-flex align-items-center">
                        <span
                          class="client-team-calendar-icon"
                          :class="'client-team-calendar-' + getCalendarStatus(row).type"
                        >
                          <i
                            v-if="getCalendarStatus(row).type === 'linked'"
                            class="icon-link"
                          ></i>
                          <i
                            v-else-if="getCalendarStatus(row).type === 'own'"
                            class="icon-calendar"
                          ></i>
                          <i
                            v-else
                            class="icon-calendar"
                          ></i>
                        </span>
                        <div class="ml-3 client-team-calendar-text">
                          <template v-if="getCalendarStatus(row).type === 'linked'">
                            <div>{{ $t('lang.label.client_team_calendar_synced_with') }}</div>
                            <div class="text-secondary small">{{ getCalendarStatus(row).email }}</div>
                          </template>
                          <template v-else-if="getCalendarStatus(row).type === 'own'">
                            <div>{{ $t('lang.label.client_team_calendar_personal') }}</div>
                            <div class="text-secondary small">{{ getCalendarStatus(row).email }}</div>
                          </template>
                          <template v-else>
                            <div>{{ $t('lang.label.client_team_calendar_label') }}</div>
                            <div class="text-secondary small">{{ $t('lang.label.client_team_calendar_not_synced') }}</div>
                          </template>
                        </div>
                      </div>
                    </td>
                    <td class="text-right client-team-actions-col">
                      <div class="dropdown d-inline-block">
                        <button
                          type="button"
                          class="btn btn-link client-team-kebab p-0"
                          data-toggle="dropdown"
                          aria-haspopup="true"
                          aria-expanded="false"
                        >
                          <span class="icon-more_horiz"></span>
                        </button>
                        <div class="dropdown-menu dropdown-menu-right client-team-dropdown">
                          <button
                            v-if="!isCurrentUser(row)"
                            type="button"
                            class="dropdown-item d-flex align-items-center"
                            @click="openEditRole(row)"
                          >
                            <i class="icon-user mr-2"></i>
                            {{ $t('lang.label.client_team_edit_role') }}
                          </button>
                          <button
                            type="button"
                            class="dropdown-item d-flex align-items-center"
                            @click="editEmail(row.id)"
                          >
                            <i class="icon-mail mr-2"></i>
                            {{ $t('lang.label.client_team_edit_email') }}
                          </button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
                <tbody v-else>
                  <tr class="no-results-row">
                    <td :colspan="currentUser.is_agency == 1 ? 4 : 3">
                      <span class="font-weight-bold ft-1-5 text-center d-block py-3"
                        >{{ $t('lang.label.client_team_no_data') }}</span
                      >
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
          <div class="card mt-3 p-4" v-if="currentUser.role_id != 4 && currentUser.role_id != 3">
            <div class="d-flex align-items-center justify-content-between mt-5">

            <h4 class="mt-3 ">{{$t('lang.column.virtualsales')}}</h4>
              <button
                    class=" btn btn-primary"
                    @click="addSalesChild"
                    type="submit"
                    v-if="currentUser.role_id == 4"
                  >
                    <i class="icon-plus1"></i> {{ $t("lang.label.team") }}
                </button>
            </div>
                <section class="">
                  <SalesChildList :key="saleskey"></SalesChildList>
                    <Modal :name="'saleschild'" :size="'50'" :max-width="'350'"> 
                      <div class="p-4 text-center">
                        <label>
                          <h4>{{ $t("lang.user.add") }}</h4>
                        </label>
                      </div>
                      <div class="px-4 pb-4 text-center">
                        <AddTeamMember :add="true" :child="true" @newForm="addChildMemberSales($event)" />
                      </div>
                    </Modal>
            </section>

          </div>

      <!-- Edit email -->
      <Modal :name="'editEmail'" size="50">
        <div class="p-4 text-center">
          <label>
            <h4>{{ $t("lang.user.edit") }}</h4>
          </label>
        </div>
        <div class="row">
          <div class="col-12 py-0 my-0">
            <form v-on:submit.prevent class="px-4 py-0">
              <vue-form-generator
                ref="userEditEmail"
                :schema="schemaEditEmail"
                :model="this.editUser"
                :options="formOptions"
              ></vue-form-generator>
            </form>
          </div>

          <div
            class="col-8 offset-2 px-5 my-3 justify-content-center mt-4 text-center text-danger"
            v-if="emailExists"
          >
            {{ $t("lang.label.emailalreadyexists") }}
          </div>

          <div class="col-12 d-flex justify-content-center my-3">
            <button
              class="float-right btn btn-primary"
              @click="saveEmail"
              type="submit"
            >
              {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>
      </Modal>

      <Modal :name="'editRole'" size="50">
        <div class="p-4 text-center">
          <label>
            <h4>{{ $t('lang.label.client_team_edit_role') }}</h4>
          </label>
        </div>
        <div class="px-4 pb-4" v-if="editRoleUser">
          <label class="text-secondary small d-block mb-2">{{ $t('lang.label.client_team_role_label') }}</label>
          <select v-model="editRoleUser.role_id" class="form-control">
            <option value="3">{{ $t('lang.label.client_team_role_sales') }}</option>
            <option value="4">{{ $t('lang.label.client_team_role_billing') }}</option>
          </select>
          <div class="d-flex justify-content-center my-4">
            <button
              class="btn btn-primary"
              :class="btnLoading ? 'btn-loading' : ''"
              @click="saveRoleFromModal"
              type="button"
            >
              {{ $t("lang.button.save") }}
            </button>
          </div>
        </div>
      </Modal>

      <Modal :name="'sales'">
        <div class="p-4 text-center">
          <label>
            <h4>{{ $t("lang.user.add") }}</h4>
          </label>
        </div>
        <div class="px-4 pb-4 text-center">
          <AddTeamMember :add="true" @newForm="addMemberSales($event)" />
        </div>
      </Modal>

      <modal
        name="emails"
        :clickToClose="true"
        class="modal-preview p-4"
        :resizable="true"
        height="auto"
        width="70%"
        :scrollable="true"
        :max-width="800"
        :ref="modalkey"
      >
        <div class="row px-4 py-2" v-if="emails">
          <div v-for="email in emails" class="col-12 py-2 card my-2">
            <small>
              <i class="icon-checkmark text-success" v-if="email.link_id"></i>
              {{ email.from[0].email }}</small
            >
            <small>{{ getEmailDate(email.date) }}</small>
            <Fieldset :title="email.subject" :mykey="email.id" :open="false">
              {{ email.snippet }}
            </Fieldset>
          </div>
        </div>
        <LoadingSpinner v-else />
      </modal>

      <modal
        name="example"
        :clickToClose="false"
        :resizable="true"
        height="auto"
        width="80%"
      >
        <div class="p-4">
          <label>
            <h4>{{ $t("lang.user.add") }}</h4>
          </label>
          <div>
            <form v-on:submit.prevent class="px-4 py-3">
              <vue-form-generator
                ref="teamUserForm"
                :schema="schema"
                :model="this.dataUser"
                :options="formOptions"
              ></vue-form-generator>
            </form>
            <div class="mt-4" v-if="alert.message">
              <AlertError :msgError="alert.message" />
            </div>
          </div>
        </div>
        <div class="px-4 pb-4 text-center">
          <button
            class="
              btn
              large
              cursor-pointer
              font-weight-bolder
              btn-sm btn-success
              mx-1
              px-4
            "
            :disabled="request == true"
            @click="addNewUser"
          >
            {{ $t("lang.button.send") }}
          </button>

          <button
            class="
              btn
              large
              cursor-pointer
              font-weight-bolder
              btn-sm btn-outline-dark
              mx-1
              px-4
            "
            @click="cerrar"
          >
            {{ $t("lang.button.back") }}
          </button>
        </div>
      </modal>
    </main>
  </section>
</template>
<script>
import { mapState, mapActions } from "vuex";
import { statusPointMixin } from "@/_mixins/";
import { clientsService, usersService } from "@/_services";
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import AlertError from "@/components/AlertError.vue";
import VueFormGenerator from "vue-form-generator";
import "vue-form-generator/dist/vfg.css";
import Tutorial from "@/components/Tutorial.vue";
import Fieldset from "@/components/Common/Fieldset.vue";
import moment from "moment";
import AddTeamMember from "@/components/Onboarding/AddTeamMember.vue";
import SalesChildList from "@/components/Team/SalesChildList.vue"; 
import Modal from "@/components/Common/Modal.vue";
import Tooltip from "@/components/Common/Tooltip.vue";

export default {
  props: {
    userId: {
      type: String,
      default: "0"
    },
    simplify: {
      type: Boolean,
      default: false
    },
    listProfileComplete: {
      type: Boolean,
      default: false
    },
    isBillingSaleOrSales: {
      type: Boolean,
      default: false
    },
    isBilling: {
      type: Boolean,
      default: false
    },
    isSales: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      avatarPlaceholder:
        "data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSIxNiIgZmlsbD0iIzkwY2FmOSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iMTIiIHI9IjUiIGZpbGw9IndoaXRlIi8+PHBhdGggZD0iTTE2IDE4Yy02LjYgMC0xMiA0LjItMTIgOXYxYzAgMS4xLjkgMiAyIDJoMjhjMS4xIDAgMi0uOSAyLTJ2LTFjMC00LjgtNS40LTktMTItOXoiIGZpbGw9IndoaXRlIi8+PC9zdmc+",
      editRoleUser: null,
      btnLoading: false,
      saleskey:23232323,
      emailExists: false,
      editUser: null,
      sincronized: 0,
      emails: false,
      editRole: false,
      result_invitation: "",
      dataUsers: [],
      request: false,
      loadingteam: false,
      modalkey: 212112,
      dataUser: {},
      schemaEditEmail: {
        fields: [
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "newEmail",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 255,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required")
              }),
              "emailValidator"
            ],
            styleClasses: "col-12 mb-4 py-0"
          }
        ]
      },
      schema: {
        fields: [
          {
            type: "input",
            inputType: "hidden",
            model: "id",
            readonly: true,
            featured: false,
            disabled: true
          },
          {
            type: "input",
            inputType: "hidden",
            model: "team_user_id",
            readonly: true,
            featured: false,
            disabled: true
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.email"),
            model: "email",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 255,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required")
              }),
              "emailValidator"
            ],
            styleClasses: "col-md-6"
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.title"),
            model: "title",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}"
              })
            }),
            styleClasses: "col-md-6"
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.firstname"),
            model: "name",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}"
              })
            }),
            styleClasses: "col-md-6"
          },
          {
            type: "input",
            inputType: "text",
            label: this.$t("lang.label.lastname"),
            model: "lastname",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            min: 5,
            max: 30,
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required"),
              textTooSmall: this.$t("lang.validation.texttosmall", {
                min: "{1}"
              })
            }),
            styleClasses: "col-md-6"
          },
          {
            type: "input",
            inputType: "password",
            label: this.$t("lang.label.password"),
            model: "password",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required")
              }),
              "validatePassword"
            ],
            styleClasses: "col-md-6"
          },
          {
            type: "input",
            inputType: "password",
            label: this.$t("lang.label.confirmpassword"),
            model: "confirm_password",
            featured: true,
            readonly: false,
            required: true,
            disabled: false,
            validator: [
              VueFormGenerator.validators.string.locale({
                fieldIsRequired: this.$t("lang.label.required")
              }),
              "confirmPasswordValidator"
            ],
            styleClasses: "col-md-6"
          },
          {
            type: "select",
            label: this.$t("lang.label.role"),
            model: "role_id",
            readonly: false,
            featured: true,
            required: true,
            validator: VueFormGenerator.validators.required,
            selectOptions: {},
            values: function() {
              return [
                { id: "2", name: "Admin" },
                { id: "3", name: "Sales rep" },
                { id: "4", name: "Billing" }
              ];
            },
            validator: VueFormGenerator.validators.string.locale({
              fieldIsRequired: this.$t("lang.label.required")
            }),
            styleClasses: "col-md-12"
          }
        ]
      },
      formOptions: {
        validateAfterLoad: false,
        validateAfterChanged: true
      }
    };
  },

  mixins: [statusPointMixin],

  components: {
    LoadingSpinner,
    "vue-form-generator": VueFormGenerator.component,
    AlertError,
    Tutorial,
    Fieldset,
    AddTeamMember,
    Modal,
    Tooltip,
    SalesChildList
  },

  watch: {
    "editUser.newEmail": {
      handler(newEmail) {
        this.emailExists = false;
      },
      immediate: false
    }
  },
  computed: {
    ...mapState({
      loading: state => state.companies.loading,
      alert: state => state.alert,
      currentUser: state => state.authentication.user,
      plans: state => state.plans.all,
      hasDeclinedPayments: state =>
        state.authentication.toastNotificationData.hasDeclinedPayments.length >
        0
    }),
    proComplete() {
      const jobTitle = this.currentUser.title;
      const avatar = this.currentUser.avatar;
      return jobTitle && avatar ? true : false;
    }
  },
  created() {
    this.getData();
    const item = {
      name: "avatar",
      value: this.currentUser.avatar ? true : false
    };
    this.setStatusOnboarding(item);
  },

  methods: {
    ...mapActions("onboarding", {
      goToSettingAccount: "goToSettingAccount",
      setStatusOnboarding: "setStatusOnboarding"
    }),
    ...mapActions("users", {
      getAllUserTeam: "getAllUserTeam"
    }),

    ...mapActions("header", {
      changeHeaderTab: "changeTab"
    }),
    editEmail(id) {
      const userFound = this.dataUsers.find(e => e.id === id);
      this.editUser = {
        id: userFound.id,
        email: userFound.email,
        newEmail: userFound.email,
        client_id: this.currentUser.client_id
      };
      this.$modal.show("editEmail");
    },
    saveEmail() {
      this.$refs.userEditEmail.validate();
      if (this.$refs.userEditEmail.errors.length > 0) {
        return;
      }
      if (this.editUser.email === this.editUser.newEmail) {
        this.$modal.hide("editEmail");
        return;
      }
      usersService
        .editEmail(this.editUser)
        .then(resp => {
          if (resp) {
            this.$swal({
              type: "success",
              title: this.$t("lang.label.great"),
              text: this.$t("lang.label.datasavedsuccessfully"),
              showConfirmButton: false,
              timer: 1500
            });
            this.dataUsers.find(
              e => e.id === this.editUser.id
            ).email = this.editUser.newEmail;
            this.$modal.hide("editEmail");
          }
        })
        .catch(err => {
          if (err === "access_denied") {
            this.$modal.hide("editEmail");
            this.$swal({
              type: "error",
              title: err,
              text: $t('lang.label.emailalreadyexists'),
              showConfirmButton: false,
              timer: 2500
            });
          }
          if (err === "exists") {
            this.emailExists = true;
          }
        });
    },
    connect(user) {
      usersService
        .getAuthenticationUrl(
          user.nylas_email_sync,
          user.name,
          user.lastname,
          user.id
        )
        .then(
          result => {
            window.open(result, "_blank");
          },
          error => {
            this.$store.dispatch("alert/error", error, { root: true });
          }
        );
    },
    getEmailDate(emaildate) {
      var momentObj = moment(emaildate * 1000);
      var momentString = momentObj.format("YYYY-MM-DD H:m:s");
      return momentString;
    },
    openEmails(user_id, limit, page) {
      this.emails = false;
      this.$modal.show("emails");
      this.modalkey++;
      clientsService.getNylasEmails(user_id, limit, page).then(result => {
        this.emails = result;
      });
    },
    closeModal() {
      this.emails = false;
      this.$modal.hide("emails");
    },
    getData() {
      this.loadingteam = true;
      if (this.currentUser.is_agency == 1) {
        usersService.getGroupList().then(result => {
          this.dataUsers = result;
          this.dataUsers.forEach(res => {
            res.editRole = false;
            if (res.nylas_email_sync_status == 1) {
              this.sincronized++;
            }
            //profileComplete  show if the user has data in the avatar, title property
            if (res.title && res.avatar) {
              res.profileComplete = true;
            } else {
              res.profileComplete = false;
            }
          });

          this.loadingteam = false;
        });
      } else {
        usersService.getAll().then(result => {
          this.dataUsers = result;
          this.dataUsers.forEach(res => {
            if (res.nylas_email_sync_status == 1) {
              this.sincronized++;
            }
          });
          this.loadingteam = false;
        });
      }
    },
    addUserTeam() {
      this.$store.dispatch("alert/clear");
      this.dataUser = { team_user_id: this.userId };
      this.$modal.show("example");
    },

    addSales() {
      this.$modal.show("sales");
    },

    addSalesChild() {
      this.$modal.show("saleschild");
    },
    addMemberSales(member) {
      usersService.addSalesRep(member).then(resp => {
        if(resp == "notunique" || (typeof resp === "string" && resp.includes("notunique"))){
            this.$modal.hide("sales");
            this.$swal({
              type: "error",
              title: this.$t('lang.label.emailalreadyexists'),
              text: this.$t('lang.general.reachouttoourteam'),
              showConfirmButton: true,
              timer: 6500
            }).then((result) => {
              this.$modal.show("sales");
            });
            return;
        }


        if (resp) {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 1500
          });
          this.$modal.hide("sales");
          this.getData();
        }
      }).catch((error) => {
        const message = typeof error === "string" ? error : "";
        this.$modal.hide("sales");
        this.$swal({
          type: "error",
          title: message.includes("notunique")
            ? this.$t("lang.label.emailalreadyexists")
            : this.$t("lang.label.error"),
          text: message.includes("notunique")
            ? this.$t("lang.general.reachouttoourteam")
            : this.$t("lang.label.error"),
          showConfirmButton: true,
        }).then(() => {
          this.$modal.show("sales");
        });
      });
    },
    addChildMemberSales(member) {
      usersService.addSalesRepChild(member.sales_representative_id.id,NULL).then(resp => {
          this.$swal({
            type: "success",
            title: this.$t("lang.label.great"),
            text: this.$t("lang.label.datasavedsuccessfully"),
            showConfirmButton: false,
            timer: 1500
          });
          this.$modal.hide("saleschild");
          this.saleskey++
      }).catch(() => {
          this.$modal.hide("saleschild");
          this.$swal({
            type: "error",
            title: this.$t("lang.label.error"),
            text: this.$t("lang.label.error"),
            showConfirmButton: true,
          });
      });
    },

    cerrar() {
      this.$modal.hide("example");
      this.request = false;
    },

    addNewUser() {
      this.$refs.teamUserForm.validate();
      if (this.$refs.teamUserForm.errors.length > 0) {
        return;
      }

      const price = this.currentUser.plan_price;
      const price1 = (
        this.currentUser.plan_price * this.currentUser.recurring_payment_period
      ).toFixed(2);

      let price2;

      const rightNow = new Date();

      const nextPaymentDate = new Date(this.currentUser.next_payment_date); //2021-11-17 15:25:09

      let timeLeft = nextPaymentDate.getTime() - rightNow.getTime();

      timeLeft = Math.round(timeLeft / (1000 * 60 * 60 * 24));

      if (this.currentUser.recurring_payment_period == 12) {
        timeLeft = Math.ceil(timeLeft / 30);
        price2 = (price * timeLeft).toFixed(2);
      } else {
        price2 = ((price / 30) * timeLeft).toFixed(2);
      }

      this.cerrar();
      this.$swal({
        type: "warning",
        title: this.$t("lang.user.messagepayment"),
        html: this.$t("lang.user.messagepaymentinfo", {
          price: price1 + " €",
          price2: price2 + " €"
        }),
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        confirmButtonText: this.$t("lang.button.yes"),
        cancelButtonColor: "#d33a2c",
        cancelButtonText: this.$t("lang.button.cancel")
      }).then(result => {
        if (result.value) {
          this.request = true;
          const { dataUser } = this;
          const { dispatch } = this.$store;
          dispatch("authentication/addNewUser", { dataUser }).then(
            reponse => {
              this.getData();
              this.cerrar();
              this.request = false;
              this.$swal.fire("", this.$t("lang.user.usercreated"), "success");
            },
            error => {
              this.request = false;
              this.$swal.fire("", this.$t("lang.user.usernotcreated"), "error");
            }
          );
        }
      });
    },

    showWarning(role_id) {
      return role_id == 2;
    },

    warmupDays(date) {
      var date1 = new Date(date);
      var date2 = new Date();

      // To calculate the time difference of two dates
      var days = parseInt(
        (date2.getTime() - date1.getTime()) / (1000 * 3600 * 24)
      );
      return days;
    },
    gotProfile() {
      this.goToSettingAccount(true);
      this.$router.push({ name: "settings-account" });
    },
    isCurrentUser(row) {
      return String(this.currentUser.id) === String(row.id);
    },
    getCalendarStatus(row) {
      if (row.referencing_calendar && String(row.referencing_calendar) !== "0") {
        return { type: "linked", email: row.referencing_calendar };
      }
      if (row.nylas_email_sync) {
        return { type: "own", email: row.nylas_email_sync };
      }
      return { type: "none" };
    },
    getRoleLabel(roleId) {
      return String(roleId) === "4"
        ? this.$t("lang.label.client_team_role_billing")
        : this.$t("lang.label.client_team_role_sales");
    },
    getAvatarColorClass(key) {
      return Number(key) % 2 === 0
        ? "client-team-avatar-a"
        : "client-team-avatar-b";
    },
    openEditRole(row) {
      this.editRoleUser = {
        id: row.id,
        role_id: String(row.role_id)
      };
      this.$modal.show("editRole");
    },
    saveRoleFromModal() {
      if (!this.editRoleUser) {
        return;
      }
      const user = this.dataUsers.find(
        e => String(e.id) === String(this.editRoleUser.id)
      );
      if (!user) {
        return;
      }
      user.role_id = this.editRoleUser.role_id;
      this.changeRole(user, true);
    },
    changeRole(user, closeModal) {
      this.btnLoading = true;
      usersService.changeRoleUserTeam(user.id, user.role_id).then(res => {
        this.dataUsers.forEach(element => {
          if (element.id == user.id) {
            element.role_name = this.setRoleName(user.role_id);
            this.btnLoading = false;
            if (closeModal) {
              this.$modal.hide("editRole");
              this.editRoleUser = null;
            }
          }
        });
      });
    },
    getBadgeTargetStatus(status) {
      switch (status) {
        case "1":
          return "btn-success";
          break;
        case "2":
          return "btn-danger";
          break;
        case "3":
          return "btn-warning";
          break;
        case "4":
          return "btn-success";
          break;
        case "5":
          return "btn-secondary";
          break;
      }
    },

    setRoleName(role) {
      switch (role) {
        case "3":
          return this.$t("lang.label.client_team_role_sales_rep");
        case "4":
          return this.$t("lang.label.client_team_role_billing");
        case "5":
          return this.$t("lang.label.client_team_role_agency");
        case "7":
          return this.$t("lang.label.client_team_role_referral");
        default:
          return "";
      }
    }
  }
};
</script>

<style scoped>
.datepicker {
  transform: translate(0, 3.1em);
}

.client-team-title {
  font-weight: 600;
  color: #1a1a2e;
}

.client-team-count {
  display: inline-block;
  margin-left: 0.35rem;
  padding: 0.1rem 0.5rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: #6c757d;
  background: #f1f3f5;
  border-radius: 999px;
  vertical-align: middle;
}

.client-team-subtitle {
  font-size: 0.9rem;
}

.client-team-table thead th {
  border-top: 0;
  border-bottom: 1px solid #e9ecef;
  font-size: 0.7rem;
  font-weight: 600;
  letter-spacing: 0.04em;
  color: #9ca3af;
  text-transform: uppercase;
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}

.client-team-table tbody td {
  vertical-align: middle;
  padding-top: 1rem;
  padding-bottom: 1rem;
  border-top: 1px solid #f0f0f0;
}

.client-team-actions-col {
  width: 48px;
}

.client-team-avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.client-team-avatar-a {
  background-color: #fef3c7;
}

.client-team-avatar-b {
  background-color: #ede9fe;
}

.client-team-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.client-team-user-name {
  font-weight: 600;
  color: #1a1a2e;
  line-height: 1.3;
}

.client-team-you-badge {
  display: inline-block;
  margin-left: 0.35rem;
  padding: 0.1rem 0.45rem;
  font-size: 0.7rem;
  font-weight: 500;
  color: #7c3aed;
  background: #ede9fe;
  border-radius: 999px;
  vertical-align: middle;
}

.client-team-user-email {
  font-size: 0.85rem;
}

.client-team-role-badge {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  font-weight: 500;
  border-radius: 0.35rem;
}

.client-team-role-sales {
  color: #6d28d9;
  background: #ede9fe;
}

.client-team-role-billing {
  color: #b45309;
  background: #fef3c7;
}

.client-team-calendar-icon {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  font-size: 0.95rem;
}

.client-team-calendar-linked {
  color: #fff;
  background: #22c55e;
}

.client-team-calendar-own {
  color: #fff;
  background: #3b82f6;
}

.client-team-calendar-none {
  color: #fff;
  background: #d1d5db;
}

.client-team-calendar-text {
  font-size: 0.875rem;
  line-height: 1.35;
}

.client-team-kebab {
  color: #6b7280;
  font-size: 1.25rem;
  line-height: 1;
  border: none;
  box-shadow: none;
}

.client-team-kebab:hover {
  color: #374151;
}

.client-team-dropdown {
  min-width: 200px;
  padding: 0.35rem 0;
  border: none;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.12);
}

.client-team-dropdown .dropdown-item {
  font-size: 0.9rem;
  padding: 0.5rem 1rem;
  color: #374151;
}

.client-team-dropdown .dropdown-item:hover {
  background: #f9fafb;
}
</style>

